import 'core-js/es6';
import 'core-js/fn/array/includes';
import 'url-api-polyfill';

// by adding this to the very top of the application, we can better catch
// boot errors in code we wrote
import './components/sentry';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

window.__REACT_VERSION__ = React.version;


import 'react-helmet';
import 'react-router';
import 'moment';
import 'jquery';
import 'lodash';

import 'jquery-migrate';

import '@reverbdotcom/commons/dist/elog';
import 'jquery-ujs';
import 'alt';
import '@reverbdotcom/adyen-cse-js';
import 'accounting';
import 'react-apollo';
import 'history';
import '@sentry/browser';
import 'react-modal';
import 'fuse.js';
import 'react-image-crop';
import 'alt-container';
import 'whatwg-fetch';
import 'js-cookie';
import 'apollo-cache-inmemory';
import 'qs';
import 'tslib';
import 'react-datetime';
import 'dompurify/dist/purify';
import 'apollo-utilities/lib';
import 'react-tracking';
import 'react-autowhatever';
import 'react-autosuggest';
import 'chartist';


import 'i18n-js';

import './vendor/jquery-powertip/jquery.powertip';
import '@reverbdotcom/discovery-ui/dist/vendor/jquery-fancybox';
import './vendor/jquery.hoverIntent';
import './vendor/temporal';
import './vendor/jquery.sortable';
import './vendor/jquery.ui.widget';
import './vendor/jquery.iframe-transport';
import './vendor/jquery.fileupload';
import './vendor/jquery.cloudinary';

import './vendor/fotorama';
import './components/chartist-with-plugins';
import './vendor/chosen/chosen';



// WEBPACK FOOTER //
// ./javascripts/vendor.js